module.exports = __webpack_public_path__ + "img/system.19ae0939.jpg";